import React, { useEffect, useState } from "react";
import "./Home.css";
import {
  AboutImg,
  Faq,
  Logo,
  RetailerImg,
  WholesalerImg,
} from "../../images/Images";
import GradientButton from "../../components/button/Button";
import PlainButton from "../../components/button/PlainButton";
import WholesalerOptionsList from "../../components/wholesaler/WholesalerOptionsList";
import RetailerOptionsList from "../../components/retailer/RetailerOptiosList";
import ContactCards from "../../components/contact/ContactCards";
import FAQSection from "../../components/faq/Faq";
import Footer from "../../components/footer/Footer";
import { CloseIcon, MenuIcon } from "../../components/icons/Icons";

const HomePage: React.FC = () => {
  const [activeId, setActiveId] = useState(""); // State to track active ID
  const width = window.innerWidth;
  const [tabOpen, setTabOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["home", "contact", "faq"];
      sections.forEach((id) => {
        const section = document.getElementById(id);
        if (section) {
          const { top, bottom } = section.getBoundingClientRect();
          if (top <= 100 && bottom >= 100) {
            setActiveId(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setTabOpen(!tabOpen);
    if (!tabOpen) {
      document.body.classList.add("locked");
    } else {
      document.body.classList.remove("locked");
    }
  };

  return (
    <div className="home__page" id="home">
      <div className="home__header">
        <div className="logo">
          <img src={Logo} alt="logo" />
        </div>

        <div className="navs">
          <ul className="navs__list">
            <li className="navs__item">
              <a
                href="#home"
                className={`navs__link ${
                  activeId === "home" ? "navs__link--active" : ""
                }`}
              >
                Home
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#contact"
                className={`navs__link ${
                  activeId === "contact" ? "navs__link--active" : ""
                }`}
              >
                Contact Us
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#faq"
                className={`navs__link ${
                  activeId === "faq" ? "navs__link--active" : ""
                }`}
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>
      </div>

      {tabOpen && (
        <div className="navs mobile">
          <ul className="navs__list">
            <li className="navs__item">
              <a
                href="#home"
                className={`navs__link ${
                  activeId === "home" ? "navs__link--active" : ""
                }`}
              >
                Home
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#contact"
                className={`navs__link ${
                  activeId === "contact" ? "navs__link--active" : ""
                }`}
              >
                Contact Us
              </a>
            </li>
            <li className="navs__item">
              <a
                href="#faq"
                className={`navs__link ${
                  activeId === "faq" ? "navs__link--active" : ""
                }`}
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>
      )}

      {width <= 900 && (
        <div className="mobile__nav">
          <div className="logo">
            <img src={Logo} alt="logo" />
          </div>

          <div className="nav__burger">
            {tabOpen ? (
              <CloseIcon onClick={toggleNav} />
            ) : (
              <MenuIcon onClick={toggleNav} />
            )}
          </div>
        </div>
      )}

      <div className="home__hero">
        <div className="hero__title">
          <h1>We are bringing the world home</h1>
        </div>

        <div className="home__hero__desc">
          Pamundo makes shopping of traditional spices, locally sourced produce,
          and artisanal goods easier and faster, connecting you to your heritage
          flavors and more.
        </div>

        <div className="home__hero__cta">
          {/* <div onClick={() => (window.location.href = "/retail")}>
            <GradientButton text="Retailer" />
          </div> */}

          <div onClick={() => (window.location.href = "/retail")}>
            <PlainButton text="Retailer" bgColor="green" textColor="white" />
          </div>
          <div onClick={() => (window.location.href = "/login")}>
            <PlainButton text="Wholesaler" />
          </div>
        </div>
      </div>
      <div className="home__about__section">
        <div className="about__img">
          <img src={AboutImg} alt="about" />
        </div>

        <div className="about__desc">
          <h3>About Us</h3>
          <p>
            Discover Pamundo, your trusted ethnic grocery marketplace bridging
            the gap between wholesalers and retailers. At Pamundo, we simplify
            the grocery procurement process of ethnic products, ensuring
            quality, affordability, and convenience. Founded by industry
            experts, our mission is to streamline the supply chain, reducing
            costs and saving time for both small and large businesses.
          </p>
        </div>
      </div>

      <div className="home__works">
        <h3>How it works (For Wholesaler)</h3>

        <p>
          Expand your reach by connecting with retailers across the region. With
          Pamundo, it’s easy.
        </p>

        <div className="btn wholesaler">
          <GradientButton text="Get started as Wholesaler" />
        </div>
        <div className="home__wholesales">
          <WholesalerOptionsList />
          <div className="wholesale__option__image">
            <img src={WholesalerImg} alt="wholesale" />
          </div>
        </div>
      </div>

      <div className="home__works">
        <h3>How it works (For Retailers)</h3>

        <p>
          Join Pamundo to easily source your grocery needs from a vast network
          of verified wholesalers.
        </p>

        <div className="btn retailer">
          <GradientButton text="Get started as Retailer" />
        </div>
        <div className="home__wholesales">
          <div className="wholesale__option__image">
            <img src={RetailerImg} alt="wholesale" />
          </div>
          <RetailerOptionsList />
        </div>
      </div>

      <div className="home__contact" id="contact">
        <h3>Contact Us</h3>

        <p>
          Have questions or need assistance? Our dedicated support team is here
          to ensure your experience on Pamundo is smooth and successful. Contact
          us through:
        </p>

        <ContactCards />
      </div>

      <div className="home__faq" id="faq">
        <div className="faq__section">
          <FAQSection />
        </div>
        <div className="faq__image">
          <img src={Faq} alt="faq" />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default HomePage;
